import { Form } from '@ant-design/compatible'

import ManagePumpingSystemForm from './ManagePumpingSystemForm'

export default Form.create({
  name: 'pumpingSystemForm',
})(ManagePumpingSystemForm)
